import { Icon, ICONS } from '@bob/library'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import { mapCurriculum } from '@websrc/DataMappers/mapSpot'
import {
  CSSoftwareApplications,
  CSSoftwareApplications_Language_Entry,
} from '@websrc/Typings/ContentStack'
import React, { useMemo } from 'react'

import * as SC from './SpotCurriculumItem.style'

export interface SpotCurriculumItemProps {
  item: ReturnType<typeof mapCurriculum>['curriculum']['curriculum'][0]
  platform: CSSoftwareApplications['operating_system']
  lang: CSSoftwareApplications_Language_Entry['entry']['language']
  lazyLoadImage?: boolean
}

export function SpotCurriculumItem({
  item,
  platform,
  lang,
  lazyLoadImage,
}: SpotCurriculumItemProps) {
  const t = useStaticText()

  const url = useMemo(() => {
    let download = item.downloads.find((d) => d.operating_system === platform)

    if (!download) {
      download = item.downloads.find((d) => d.operating_system === 'All devices')
    }

    return download?.language.find((l) => l.language === lang)?.url || undefined
  }, [item, lang, platform])

  return (
    <SC.Wrapper data-testid={'download-url'} download={true} href={url} target={'_blank'}>
      {item.thumbnail && (
        <SC.ProductImage
          {...item.thumbnail}
          fit={'crop'}
          height={200}
          lazyLoading={lazyLoadImage}
          width={400}
        />
      )}
      <SC.TextWrapper>
        <SC.Title>{item.headline}</SC.Title>
        <SC.Description>{item.description}</SC.Description>
      </SC.TextWrapper>
      <SC.ButtonTertiary onClick={() => window.open(url)}>
        <Icon icon={ICONS.ARROW_RIGHT} size={12} />
        <span>{t.downloads.button_text_download}</span>
      </SC.ButtonTertiary>
    </SC.Wrapper>
  )
}
